/**
 * Postage reducer
 * 
 */
import { DELETE, DELIVERY_ADDRESS, POSTAGE } from '../../actions/types';
import { POSTAGE as RATES } from '../../data/Data';
export const initialState = RATES[0];
export default function (state = initialState, action) {
  switch (action.type) {
    case DELETE:
      return initialState;
    case DELIVERY_ADDRESS:
      {
        const {
          value
        } = action;
        if (value === 'International') {
          return {
            ...RATES[1]
          };
        }
        return {
          ...RATES[0]
        };
      }
    case POSTAGE:
      {
        return {
          ...action.value
        };
      }
    default:
      return state;
  }
}